<template>
  <div>
    <v-layout
      row
      align-center
      :style="myLayoutStyle"
    >
      <v-flex
        xs12
        sm10
        offset-sm1
        md10
        offset-md1
        lg10
        offset-lg1
        xl8
        offset-xl2
      >
        <v-card
          flat
          :color="theme.bg_color"
          v-if="membershipConfig"
        >
          <v-card-text>
            <page-title :title="membershipConfig.page_header" />
            <div
              class="mt-2"
              :style="aboutStyle"
            >
              <div v-html="membershipConfig.content">
              </div>
            </div>
          </v-card-text>
        </v-card>
      </v-flex>
    </v-layout>
    <v-footer
      fixed
      app
      inset
      :height="theme.footer_height"
      :color="theme.footer_bg_color"
      v-if="membershipConfig"
    >
      <v-btn
        block
        dark
        large
        class="btn"
        :color="theme.btn_color_primary"
      >
        <v-layout row>
          <v-flex
            xs12
            class="text-xs-center"
            @click="goToNextPage"
          >
            Upgrade Now
          </v-flex>
        </v-layout>
      </v-btn>
    </v-footer>
  <form
    id="payment-membership"
    :action="'https://epay.aptsys.com.sg/2c2p/web'"
    method="post"
    v-if="activeOrderMembership"
  >
    <input
      type="hidden"
      name="member_id"
      :value="profile.loyalty_member_id"
    />
    <input
      type="hidden"
      name="loyalty_group_id"
      :value="loyaltyGroupId"
    />
    <input
      type="hidden"
      name="platform_id"
      :value="posType === 0 ? 3 : 4"
    />
    <input
      type="hidden"
      name="platform_transaction_id"
      :value="activeOrderMembership.reference_id"
    />
    <input
      type="hidden"
      name="is_guest"
      :value="0"
    />
    <input
      type="hidden"
      name="reference_id"
      :value="activeOrderMembership.reference_id"
    />
    <input
      type="hidden"
      name="transaction_amount"
      :value="activeOrderMembership.payments_topay"
    />
    <input
      type="hidden"
      name="restaurant_id"
      :value="rid"
    />
    <input
      type="hidden"
      name="account"
      :value="epayAccount"
    />
    <input
      type="hidden"
      name="payment_mode"
      :value="'c2p'"
    />
    <input
      type="hidden"
      name="payment_time"
      value="payBeforeServe"
    />
    <input
      type="hidden"
      name="redirect_url"
      :value="redirectUrl"
    />
    <input
      type="hidden"
      name="hash"
      :value="hash"
    />
  </form>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import PageTitle from '~/components/PageTitle'
import axios from 'axios'

export default {
  name: 'reservation-tnc-view',
  metaInfo () {
    return { title: this.$t('reservations') }
  },
  data () {
    return {
      articles: [],
      img: '',
      hash: '',
      redirectUrl: window.config.url + '/membership_purchased'
    }
  },
  components: {
    'page-title': PageTitle
  },
  computed: {
    ...mapGetters('config', [
      'theme', 'mode', 'restaurantContact', 'restaurantAddress', 'openingHours', 'reservationConfig', 'rid',
      'posType', 'loyaltyGroupId', 'epayAccount'
    ]),
    ...mapGetters('auth', [
      'authenticated'
    ]),
    ...mapGetters('member', [
      'isMember', 'membership', 'membershipConfig', 'activeOrderMembership','activeOrderPaymentsMembership',
      'profile'
    ]),
    myLayoutStyle () {
      return {
        marginLeft: '-8px',
        marginRight: '-8px',
        marginBottom: '-16px',
        backgroundColor: this.theme.bg_color
      }
    },
    aboutStyle () {
      return {
        fontSize: '13px',
        color: this.theme.title_color
      }
    },
    tncStyle () {
      return {
        color: this.theme.title_color
      }
    }
  },
  methods: {
    async goToNextPage () {
      this.$bus.$emit('showFullLoading', true)

      // Get hash from server
      const { data } = await axios.post('/api/epay/md5', {
        guest_id: 0, // this.guestId
        loyalty_group_id: this.loyaltyGroupId,
        restaurant_id: this.rid,
        transaction: this.activeOrderMembership,
        type: 'payBeforeServe'
      })
      this.hash = data

      // Wait for 1 second before submitting since the form input is not set immediately
      setTimeout(async () => {
        // Prevent submit if platformTransactionId/hash is 0 or null
        const formPlatformTransactionId = this.posType === 0 ? 3 : 4
        const formReferenceId = this.activeOrderMembership.reference_id
        const formHash = this.hash
        if (!this.activeOrderMembership || !formPlatformTransactionId || !formReferenceId || !formHash || formPlatformTransactionId == 0 || formReferenceId == 0) {
          this.$store.dispatch('responseMessage', {
            type: 'error',
            title: 'Unable to checkout',
            text: 'Failed to check order from server. Please try again',
            modal: true
          })
          this.$bus.$emit('showFullLoading', false)
          return
        }

        await this.$store.dispatch('member/saveActiveOrderMembershipEpayClientRef')
        this.$bus.$emit('showFullLoading', false)

        this.logPaymentData()
        document.getElementById('payment-membership').submit()
        // await axios.post('https://epaydev.aptsys.com.sg/cybersource/web', {
        //   member_id: this.member_id,
        //   loyalty_group_id: this.loyaltyGroupId,
        //   platform_id: 3,
        //   platform_transaction_id: this.activeOrderMembership.reference_id,
        //   is_guest: 0,
        //   reference_id: this.activeOrderMembership.reference_id,
        //   transaction_amount: this.activeOrderMembership.payments_topay,
        //   restaurant_id: this.rid,
        //   account: this.epayAccount,
        //   payment_mode: 'c2p',
        //   payment_time: 'payBeforeServe',
        //   redirect_url: window.config.url + '/membership_purchase',
        //   hash: this.hash
        // })
      }, 1000)
    },
    async logPaymentData () {
      try {
        let content = {
          ...this.activeOrderMembership,
          loyalty_group_id: document.getElementsByName('loyalty_group_id')[0].value,
          platform_id: document.getElementsByName('platform_id')[0].value,
          platform_transaction_id: document.getElementsByName('platform_transaction_id')[0].value,
          is_guest: document.getElementsByName('is_guest')[0].value,
          reference_id: document.getElementsByName('reference_id')[0].value,
          transaction_amount: document.getElementsByName('transaction_amount')[0].value,
          restaurant_id: document.getElementsByName('restaurant_id')[0].value,
          account: document.getElementsByName('account')[0].value,
          payment_mode: document.getElementsByName('payment_mode')[0].value,
          payment_time: document.getElementsByName('payment_time')[0].value,
          redirect_url: document.getElementsByName('redirect_url')[0].value,
          hash: document.getElementsByName('hash')[0].value
        }
        if (this.isMember) {
          content.member = this.profile
        }
        await axios.post('/api/log', {
          action: 'directToEPay',
          content: content
        })
      } catch (e) { }
    }
  },
  async mounted () {
    let item
    await axios.post('/api/get_membership_item', {
      membership_config_id: this.membershipConfig.id,
      restaurant_id: this.rid
    }).then(response => {
      item = response.data.result
    })
    const params = {
      item: JSON.parse(JSON.stringify(item)),
      quantity: 1,
      final_price: parseFloat(item.final_price || item.price),
    }
    await this.$store.dispatch('member/addMembershipItem', params)
    await this.$store.dispatch('member/checkFinalMembershipOrder', this.activeOrderPaymentsMembership)
  }
}
</script>

<style scoped>
.btn {
  margin: 10px;
  padding: 0 16px;
}
.middle {
  padding: 2px 4px 2px 2px;
}
.tnc-title {
  text-transform: uppercase;
  font-weight: 800;
  font-size: 14px;
}
.tnc {
  font-size: 13px;
}
</style>



// WEBPACK FOOTER //
// src/pages/membership_purchase.vue